import { color, media, spacing } from '@gyym/ui'
import styled from 'styled-components'

export const INNER_WIDTH = 848 + 40

export const ReservedProgramsSwiperContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;

  ${media.pc} {
    padding-left: calc((100vw - ${INNER_WIDTH}px) / 2);
  }
`

export const Inner = styled.div`
  background-color: ${color('gray.05')};
  width: 100%;
  padding: ${spacing(4, 0, 4, 5)};
  overflow: auto;

  .swiper-container {
    padding-right: ${spacing(5)};
  }
`

export const DateText = styled.div`
  white-space: nowrap;
`
